import react, {useEffect, useMemo} from 'react';
import MyTable from '../components/myTable';
import {useSelector} from 'react-redux';
import { useNavigate } from 'react-router-dom';
import Cookie from 'react-cookies';
import { FaPlus } from 'react-icons/fa';
import { getAllEvents, userList } from '../../api/api';

const Users = () => {
    // const marginLeft = useSelector(state => state.style.payload.marginLeft)
    const navigate = useNavigate();
    const data = useSelector((state) => state.events.events);
    console.log(data);
   
    const fetchEvents = () => {
        getAllEvents();
    }
    const columns = useMemo( () => [
        {
            Header: '#',
            accessor: (data, i) => {
                return (i+1)
            }
        },
        {
            Header: 'Poster',
            accessor: ((user) => (
                <img src={user.img} height={50} width={50} />
            ))
        },
        {
            Header: 'title',
            accessor: 'title',
        },
        {
            Header: 'Date',
            accessor: 'date'
        },
        {
            Header: 'Venue',
            accessor: 'venue'
        },
        {
            Header: 'Action',
            accessor: (data, i) => 
                (
                    <span id='' className='drop-down'
                    style={{ width: '150px' }}
                    > 
                        <button
                        // id='action'
                        className='form-select'
                         style={{ 
                            fontSize: 12
                          }}
                        onClick={() => {
                            let element = document.getElementById('child'+i);
                            
                            element.classList.toggle('open');
                        }}
                        >
                            Action
                        </button>
                        <div id={'child'+i} class="table-action-box form-control">
                             <button className='btn form-control text-start'
                             style={{ 
                                fontSize: 12
                              }}
                             onClick={() => {
                                Cookie.save('eventItem', JSON.stringify(data));
                                // navigate('/view_store_item');
                             }}
                             > View </button>

                             <button className='btn form-control text-start'
                             style={{ 
                                fontSize: 12
                              }}
                             onClick={() => {
                                Cookie.save('eventItem', JSON.stringify(data));
                                // navigate('/update_store_item');
                             }}
                             > Update </button>
                        </div>
                    </span>
                )
            
        }
    ], [])

    useEffect(() => {
        data.length == 0 && fetchEvents();
        document.title = 'Events | Bida Sport Club'
        // console.log(data)    
    }, [])
    return data.length > 0 ? (
        <div className=''> 
            {/* <h2> Users </h2> */}
            <MyTable data ={data} columns={columns} pageName = {"Events Lists"}
             button = {<button className='btn btn-md btn-color'
             style={{ 
                 // width:'170px',
                 height: '40px'
              }}
             onClick={()=> navigate('/create_event')}
             > <FaPlus /> Add Event </button>}
            />
        </div>
    ):
    (
        <div className=' row justify-content-center py-5'>
            <h4> <b className="mb-5 ms-5">Events List</b> </h4>
            <h3> <p className="mb-5 ms-5 text-center">Event List is Empty.</p> </h3>
        </div>
    )
}

export default Users